var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0d0b7f"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "18,4 18,50 57.5,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18,50 18,96 57.5,73"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.5,27 57.5,73 97,50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsiLogo);
export default __webpack_public_path__ + "static/media/CSI_Logo.83fca349ee6c86e8a40657897433250b.svg";
export { ForwardRef as ReactComponent };